import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacarrentalmumbai() {



    const cardData = {





keyword: "Innova Car Rental Mumbai",

headingDescription: "Shreesha Tours & Travels offers premium Innova Car Rental in Mumbai for local travel, airport transfers, corporate transportation, outstation trips, family vacations, business meetings, sightseeing tours, pilgrimage journeys, destination weddings, and long-distance travel across India. Our Toyota Innova and Innova Crysta rental services are ideal for families, corporate executives, tourist groups, and travelers seeking spacious seating, superior comfort, and a smooth driving experience. We provide chauffeur-driven Innova rentals with experienced drivers, well-maintained vehicles, doorstep pickup, transparent pricing, flexible travel plans, and 24/7 customer support. Whether you need an Innova for a one-way journey, round trip, multi-day tour, airport pickup, or customized outstation travel, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free experience. Our Innova rental service from Mumbai is widely preferred for business travel, religious tours, weekend getaways, and family holidays because of its reliability, generous luggage space, and comfortable seating for long-distance journeys.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most popular destinations for Innova rentals from Mumbai. Business executives, families, and corporate travelers frequently book spacious Innova vehicles for comfortable travel to Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and Pimpri-Chinchwad."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, and breathtaking viewpoints. Innova rentals are perfect for family vacations and group tours."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a favorite weekend getaway known for Tiger Point, Bhushi Dam, Rajmachi Fort, waterfalls, and beautiful valleys. An Innova provides comfortable travel for families and groups visiting this hill station."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees throughout the year. Innova rentals offer convenient and comfortable transportation for families and senior citizens visiting the Sai Baba Temple."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and business centers. Innova cabs are frequently booked for religious tours, corporate travel, and family outings."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is India's most popular beach destination, offering beaches, churches, forts, luxury resorts, nightlife, and water sports. Innova rentals are ideal for long-distance family vacations and group road trips."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a leading commercial city known for its textile and diamond industries. Business travelers prefer Innova rentals for comfortable executive travel and corporate meetings."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital with major industries, business parks, shopping destinations, and heritage attractions. Innova rental services provide a comfortable travel option for business and leisure travelers."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is famous for the Mahalakshmi Temple, Panhala Fort, Rankala Lake, and rich Maratha heritage. Innova rentals are widely preferred for religious tours and family holidays."
  },
  {
    title: "Mumbai to Bangalore",
    description: "Bangalore is India's leading IT and startup hub with multinational companies, technology parks, and business centers. Innova rentals provide spacious and comfortable long-distance transportation for corporate teams and families."
  }
],



"services": [
  {
    "name": "Innova Car Rental Mumbai",
    "description": "Book Innova Car Rental Mumbai for comfortable, spacious, and chauffeur-driven travel with well-maintained Toyota Innova and Innova Crysta vehicles. Ideal for airport transfers, family vacations, corporate travel, weddings, sightseeing tours, business meetings, and outstation trips with professional drivers, affordable pricing, and 24x7 booking support."
  },
  {
    "name": "Innova Cab Rental Mumbai",
    "description": "Choose Innova Cab Rental Mumbai for reliable transportation with experienced chauffeurs and premium AC vehicles. Our Innova cabs are perfect for local travel, airport pickup and drop, corporate travel, family functions, pilgrimage tours, and long-distance outstation journeys with flexible rental packages."
  },
  {
    "name": "Toyota Innova on Rent Mumbai",
    "description": "Hire Toyota Innova on Rent Mumbai for safe and comfortable travel with spacious seating, ample luggage space, and professional chauffeur service. Enjoy premium transportation for business trips, family holidays, group travel, airport transfers, and weekend tours at competitive rental prices."
  },
  {
    "name": "Innova Hire in Mumbai",
    "description": "Reserve Innova Hire in Mumbai for hassle-free travel with clean AC vehicles and trained drivers. Whether you need transportation for weddings, corporate events, airport transfers, local sightseeing, or outstation travel, our Innova rental service provides comfort, reliability, and punctual service."
  },
  {
    "name": "Innova Car Hire Mumbai",
    "description": "Book Innova Car Hire Mumbai with chauffeur-driven vehicles for local and outstation travel. Choose comfortable Toyota Innova models for family trips, office transportation, business meetings, holiday tours, airport transfers, and special occasions with transparent pricing and easy online booking."
  },
  {
    "name": "Innova Taxi Service Mumbai",
    "description": "Choose Innova Taxi Service Mumbai for premium travel with experienced drivers and spacious AC vehicles. Our Innova taxi service is suitable for airport transfers, railway station pickups, local travel, corporate transportation, family vacations, and long-distance journeys across India."
  },
  {
    "name": "Innova Cab Service Mumbai",
    "description": "Book Innova Cab Service Mumbai for smooth and comfortable travel with professional chauffeurs and well-maintained vehicles. Enjoy reliable transportation for local rides, airport pickup and drop, hotel transfers, business travel, sightseeing, and outstation tours with flexible travel packages."
  },
  {
    "name": "Innova Rental with Driver Mumbai",
    "description": "Hire Innova Rental with Driver Mumbai for stress-free travel with experienced chauffeurs and premium AC vehicles. Perfect for corporate executives, tourists, family groups, VIP guests, airport transfers, weddings, and intercity travel with comfortable seating and professional service."
  },
  {
    "name": "Innova Outstation Cab Mumbai",
    "description": "Reserve Innova Outstation Cab Mumbai for one way and round trip travel to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states. Enjoy spacious seating, comfortable journeys, transparent fares, and reliable chauffeur-driven transportation for family holidays, business trips, and pilgrimage tours."
  },
  {
    "name": "Innova Airport Taxi Mumbai",
    "description": "Book Innova Airport Taxi Mumbai for timely airport pickup and drop with flight tracking, luggage assistance, and experienced chauffeurs. Travel comfortably to and from Mumbai Airport in spacious Toyota Innova vehicles suitable for families, business travelers, and groups carrying extra luggage."
  },
  {
    "name": "Innova Crysta Rental Mumbai",
    "description": "Choose Innova Crysta Rental Mumbai for luxury travel with premium interiors, spacious seating, powerful performance, and professional chauffeur service. Perfect for executive travel, VIP transportation, weddings, airport transfers, sightseeing tours, and premium outstation journeys."
  },
  {
    "name": "Mumbai Innova Cab Booking",
    "description": "Complete Mumbai Innova Cab Booking online with instant confirmation, flexible pickup schedules, and affordable rental packages. Book Toyota Innova or Innova Crysta for airport transfers, local travel, corporate meetings, family vacations, and outstation journeys with 24x7 customer assistance."
  },
  {
    "name": "Mumbai Innova Taxi Booking",
    "description": "Reserve Mumbai Innova Taxi Booking for comfortable chauffeur-driven travel with premium vehicles and experienced drivers. Enjoy reliable transportation for business travel, sightseeing, family functions, hotel transfers, airport pickup and drop, and long-distance travel."
  },
  {
    "name": "Innova Car on Rent Mumbai",
    "description": "Book Innova Car on Rent Mumbai for flexible daily, hourly, weekend, and outstation rental plans. Travel comfortably in spacious AC vehicles with professional chauffeurs for family outings, weddings, business meetings, holiday tours, and airport transportation."
  },
  {
    "name": "Luxury Innova Rental Mumbai",
    "description": "Choose Luxury Innova Rental Mumbai for premium chauffeur-driven travel with Toyota Innova Crysta offering exceptional comfort, spacious interiors, modern features, and reliable performance. Ideal for VIP guests, corporate executives, weddings, airport transfers, and luxury outstation travel."
  },
  {
    "name": "Affordable Innova Rental Mumbai",
    "description": "Book Affordable Innova Rental Mumbai with budget-friendly pricing and professional chauffeur service without compromising comfort or safety. Enjoy clean AC vehicles, experienced drivers, transparent fares, and convenient booking for local, airport, and outstation travel."
  },
  {
    "name": "Innova Family Trip Cab Mumbai",
    "description": "Reserve Innova Family Trip Cab Mumbai for safe and spacious family travel with comfortable seating, large luggage capacity, and experienced drivers. Perfect for holidays, religious tours, sightseeing trips, weekend getaways, airport transfers, and long-distance family vacations."
  },
  {
    "name": "Innova Corporate Cab Mumbai",
    "description": "Choose Innova Corporate Cab Mumbai for executive transportation, employee travel, airport transfers, client meetings, conferences, and business events. Our professional chauffeurs, premium vehicles, and punctual service ensure reliable corporate travel throughout Mumbai and beyond."
  },
  {
    "name": "Mumbai to Outstation Innova Cab",
    "description": "Book Mumbai to Outstation Innova Cab for comfortable one way and round trip journeys to destinations across India. Travel in spacious Toyota Innova vehicles with professional drivers, transparent pricing, flexible travel schedules, and reliable customer support for family, business, and leisure travel."
  },
  {
    "name": "Best Innova Car Rental Mumbai",
    "description": "Choose the Best Innova Car Rental Mumbai for premium chauffeur-driven travel with Toyota Innova and Innova Crysta vehicles. Enjoy professional drivers, comfortable seating, affordable fares, reliable customer support, and exceptional service for airport transfers, weddings, corporate travel, sightseeing, and outstation journeys."
  }
],
"tableData": [
  ["Innova Car Rental Mumbai", "Innova Cab Rental Mumbai"],
  ["Toyota Innova on Rent Mumbai", "Innova Hire in Mumbai"],
  ["Innova Car Hire Mumbai", "Innova Taxi Service Mumbai"],
  ["Innova Cab Service Mumbai", "Innova Rental with Driver Mumbai"],
  ["Innova Outstation Cab Mumbai", "Innova Airport Taxi Mumbai"],
  ["Innova Crysta Rental Mumbai", "Mumbai Innova Cab Booking"],
  ["Mumbai Innova Taxi Booking", "Innova Car on Rent Mumbai"],
  ["Luxury Innova Rental Mumbai", "Affordable Innova Rental Mumbai"],
  ["Innova Family Trip Cab Mumbai", "Innova Corporate Cab Mumbai"],
  ["Mumbai to Outstation Innova Cab", "Best Innova Car Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Innova Car Rental in Mumbai",
    WhyChoosedescription: "Experience comfortable group travel with Shreesha Travels by hiring an Innova in Mumbai. Whether you're travelling for business, family vacations, airport transfers, weddings, or outstation tours, our Innova rental service offers the perfect combination of space, comfort, and reliability."
  },
  {
    WhyChooseheading: "Perfect Choice for Families & Group Travel",
    WhyChoosedescription: "Toyota Innova is ideal for travellers who require spacious seating, generous luggage capacity, and a smooth ride, making every journey enjoyable for both short and long distances."
  },
  {
    WhyChooseheading: "Travel Anywhere from Mumbai with Ease",
    WhyChoosedescription: "Book an Innova for trips to Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Surat, Ahmedabad, Kolhapur, Bengaluru, and numerous destinations across India with flexible travel options."
  },
  {
    WhyChooseheading: "Suitable for Corporate, Airport & Event Transportation",
    WhyChoosedescription: "Our Innova rental service is widely preferred for executive travel, airport transfers, client visits, conferences, destination weddings, VIP guest movement, and family celebrations."
  },
  {
    WhyChooseheading: "Flexible Rental Plans for Every Requirement",
    WhyChoosedescription: "Choose from one-way bookings, round-trip journeys, airport transfers, full-day rentals, multi-day tours, and personalized travel itineraries tailored to your schedule."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Comfortable Road Trips",
    WhyChoosedescription: "Professional drivers with extensive route knowledge ensure safe driving, timely arrivals, and a relaxed travel experience on city roads and highways."
  },
  {
    WhyChooseheading: "Well-Maintained Innova Vehicles",
    WhyChoosedescription: "Every Innova is regularly serviced, fully air-conditioned, sanitized, and inspected before every trip to provide maximum comfort and dependable performance."
  },
  {
    WhyChooseheading: "Choose Shreesha Travels for Innova Rental in Mumbai",
    WhyChoosedescription: "Benefit from transparent pricing, prompt booking support, quality service, and comfortable chauffeur-driven Innova vehicles for every travel occasion."
  }
]

};

const faqData = [
  {
    question: "Why is the Toyota Innova a popular choice for rental in Mumbai?",
    answer: "The Innova offers spacious seating, excellent ride comfort, ample luggage space, and is ideal for family trips, corporate travel, airport transfers, and long-distance journeys."
  },
  {
    question: "How many passengers can travel comfortably in an Innova?",
    answer: "The Toyota Innova comfortably accommodates up to 6–7 passengers, depending on the seating configuration and luggage."
  },
  {
    question: "Can I rent an Innova for a weekend vacation?",
    answer: "Yes, Innova rentals are available for weekend trips, holiday packages, pilgrimages, sightseeing tours, and extended vacations."
  },
  {
    question: "Is the Innova available for Mumbai Airport pickup and drop?",
    answer: "Yes, chauffeur-driven Innova vehicles are available for airport transfers to and from Mumbai International and Domestic Airports."
  },
  {
    question: "Do you provide Innova rentals for weddings and special events?",
    answer: "Yes, Innova cars are frequently booked for weddings, receptions, family functions, guest transportation, and destination events."
  },
  {
    question: "Can I hire an Innova for corporate travel?",
    answer: "Yes, executives, companies, and business travellers can reserve Innova vehicles for meetings, conferences, client visits, and official travel."
  },
  {
    question: "Is advance booking recommended for Innova rentals?",
    answer: "Yes, booking in advance helps secure vehicle availability, especially during weekends, holidays, and festive seasons."
  },
  {
    question: "Can I plan a multi-city itinerary with an Innova rental?",
    answer: "Yes, customized travel plans covering multiple destinations and overnight stays can be arranged based on your itinerary."
  },
  {
    question: "How is the Innova rental fare determined?",
    answer: "Rental charges depend on the travel distance, trip duration, vehicle type, route, and any additional travel requirements."
  },
  {
    question: "How can I book an Innova Car Rental in Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel dates, passenger count, and travel plan to receive a personalized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Chitale",
    feedback: "Every part of the journey reflected excellent planning and attention to detail. The spacious Innova, courteous chauffeur, and smooth highway drive made the entire trip exceptionally comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Bhavna Sethi",
    feedback: "Choosing an Innova from Shreesha Travels proved to be a wonderful decision for our long-distance travel. The vehicle offered outstanding comfort, plenty of luggage space, and a relaxing travel experience throughout.",
    rating: 5
  }
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Car Rental Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/innova-car-rental-mumbai.webp",
  "description":
    "Book Innova Car Rental Mumbai with Shreesha Tours & Travels for safe, spacious, and comfortable chauffeur-driven taxi services. We provide Toyota Innova and Innova Crysta rentals available 24x7 for airport transfers, corporate travel, family vacations, sightseeing, weddings, group tours, and outstation journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/innova-car-rental-mumbai"
  }
};



    return (
        <div>


<Helmet>
  <title>Innova Car Rental Mumbai | Toyota Innova on Rent | +91 8355835813</title>

  <meta
    name="description"
    content="Book Innova Car Rental Mumbai with Shreesha Travels for reliable chauffeur-driven Toyota Innova and Innova Crysta rentals. Ideal for airport transfers, local travel, corporate trips, family tours, and outstation journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Innova Car Rental Mumbai, Innova Cab Rental Mumbai, Toyota Innova on Rent Mumbai, Innova Hire in Mumbai, Innova Car Hire Mumbai, Innova Taxi Service Mumbai, Innova Cab Service Mumbai, Innova Crysta Rental Mumbai, Innova Airport Taxi Mumbai, Innova Outstation Cab Mumbai, Toyota Innova Crysta Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacarrentalmumbai;